import { render, staticRenderFns } from "./AlipaySettingsPage.vue?vue&type=template&id=effea996&scoped=true"
import script from "./AlipaySettingsPage.vue?vue&type=script&lang=js"
export * from "./AlipaySettingsPage.vue?vue&type=script&lang=js"
import style0 from "./AlipaySettingsPage.vue?vue&type=style&index=0&id=effea996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effea996",
  null
  
)

export default component.exports